module.exports = __webpack_public_path__ + "public/img/check-circle.3f66f285.png";